export default "__VITE_ASSET__D$hMZrMm__"